export const PCB_PARTS_ID = 1;